export default __webpack_public_path__ + "static/media/call_2.d22d784d.svg";